import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import Offer from "./Offer";
import User from "./User";
import Order from "./Order";
import Store from "./Store";
import Addons from "./Addons";
import OfferOption from "../sale-page/OfferOption";
import OfferUpSell from "../sale-page/OfferUpSell";
import OfferCrossSell from "../sale-page/OfferCrossSell";
import { getBlockInstance, toBase64 } from "../../../assets/js/mcn-helpers";
import Image from "../library/Image";
import Model from "./Model";
import Product from "./Product";
import CustomData from "./sale-page/CustomData";
export class SalePage extends Model {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "id", {
      id: 'sale-page-id',
      fieldName: 'sale_page_id',
      fieldTitle: 'Sale page id',
      content: null
    });
    _defineProperty(this, "Id", {
      id: 'sale-page-id',
      fieldName: 'sale_page_id',
      fieldTitle: 'Sale page id',
      content: null
    });
    _defineProperty(this, "SalePageId", {
      id: 'sale-page-id',
      fieldName: 'sale_page_id',
      fieldTitle: 'Sale page id',
      content: null
    });
    _defineProperty(this, "SalePageUserID", {
      id: 'sale-page-user-id',
      fieldName: 'user_id',
      fieldTitle: 'Sale page user id',
      content: null
    });
    _defineProperty(this, "SalePageOfferID", {
      id: 'sale-page-offer-id',
      fieldName: 'offer_id',
      fieldTitle: 'Sale page offer id',
      content: null
    });
    _defineProperty(this, "SalePageUpdatedBy", {
      id: 'sale-page-updated-by',
      fieldName: 'updated_by',
      fieldTitle: 'Sale page updated by',
      model: User,
      content: null
    });
    _defineProperty(this, "SalePageUser", {
      id: 'sale-page-user',
      fieldName: 'sale_page_user',
      fieldTitle: 'Sale page user',
      model: User,
      content: null
    });
    _defineProperty(this, "SalePageCheckoutLength", {
      id: 'sale-page-checkout-length',
      fieldName: 'checkout_length',
      fieldTitle: 'Sale page checkout length',
      content: SalePage.LONG_CHECKOUT
    });
    _defineProperty(this, "checkoutTitle", {
      fieldName: 'checkout_title',
      fieldTitle: 'Checkout title',
      content: null
    });
    _defineProperty(this, "checkoutSubTitle", {
      fieldName: 'checkout_subtitle',
      fieldTitle: 'Checkout sub title',
      content: null
    });
    _defineProperty(this, "SalePageDomainID", {
      id: 'sale-page-domain-id',
      fieldName: 'domain_id',
      fieldTitle: 'Sale page domain id',
      content: null
    });
    _defineProperty(this, "SalePageDomain", {
      id: 'sale-page-domain',
      fieldName: 'sale_page_domain',
      fieldTitle: 'Sale page domain',
      model: Store,
      content: null
    });
    _defineProperty(this, "domain", {
      id: 'sale-page-domain',
      fieldName: 'domain',
      fieldTitle: 'Sale page domain',
      model: Store,
      content: null
    });
    _defineProperty(this, "SalePageStatus", {
      id: 'sale-page-status',
      fieldName: 'sale_page_status',
      fieldTitle: 'Sale page status',
      content: null
    });
    _defineProperty(this, "SalePageLanguage", {
      id: 'sale-page-language',
      fieldName: 'sale_page_language',
      fieldTitle: 'Sale page language',
      content: null
    });
    _defineProperty(this, "SalePageBlocks", {
      id: 'sale-page-blocks',
      fieldName: 'sale_page_blocks',
      fieldTitle: 'Sale page blocks',
      dynamicModel: block => getBlockInstance(block === null || block === void 0 ? void 0 : block.type),
      content: []
    });
    _defineProperty(this, "SalePageName", {
      id: 'sale-page-name',
      fieldName: 'sale_page_name',
      fieldTitle: 'Sale page name',
      content: null
    });
    _defineProperty(this, "name", {
      id: 'sale-page-name',
      fieldName: 'sale_page_name',
      fieldTitle: 'Sale page name',
      content: null
    });
    _defineProperty(this, "SalePageShortProductName", {
      id: 'sale-page-short-product-name',
      fieldName: 'sale_page_short_product_name',
      fieldTitle: 'Sale page short product name',
      content: null
    });
    _defineProperty(this, "SalePageNickName", {
      id: 'sale-page-nick-name',
      fieldName: 'sale_page_nickname',
      fieldTitle: 'Sale page nick name',
      content: null
    });
    _defineProperty(this, "SalePageProductTitle", {
      id: 'sale-page-title',
      fieldName: 'sale_page_product_title',
      fieldTitle: 'Sale page product title',
      content: null
    });
    _defineProperty(this, "description", {
      id: 'sale-page-description',
      fieldName: 'description',
      fieldTitle: 'Sale page description',
      content: null
    });
    _defineProperty(this, "SalePageProductVideo", {
      id: 'sale-page-video',
      fieldName: 'sale_page_product_video',
      fieldTitle: 'Sale page product video',
      content: null
    });
    _defineProperty(this, "SalePageImage", {
      id: 'sale-page-image',
      fieldName: 'sale_page_image',
      fieldTitle: 'Sale page image',
      content: null
    });
    _defineProperty(this, "SalePageOfferOptions", {
      id: 'sale-page-offer-options',
      fieldName: 'sale_page_offer_options',
      fieldTitle: 'Sale page offer options',
      model: OfferOption,
      content: []
    });
    _defineProperty(this, "SalePageUpsells", {
      id: 'sale-page-upsells',
      fieldName: 'sale_page_upsells',
      fieldTitle: 'Sale page upsells',
      model: OfferUpSell,
      content: []
    });
    _defineProperty(this, "SalePageCrossSells", {
      id: 'sale-page-cross-sells',
      fieldName: 'sale_page_cross_sells',
      fieldTitle: 'Sale page cross-sells',
      model: OfferCrossSell,
      content: []
    });
    _defineProperty(this, "offer", {
      id: 'offer',
      fieldName: 'offer',
      fieldTitle: 'Sale page offer',
      model: Offer,
      content: null
    });
    _defineProperty(this, "withTrashedOffer", {
      id: 'offer',
      fieldName: 'with_trashed_offer',
      fieldTitle: 'Sale page offer',
      model: Offer,
      content: null
    });
    _defineProperty(this, "SalePageOffer", {
      id: 'sale-page-offer',
      fieldName: 'sale_page_offer',
      fieldTitle: 'Sale page offer',
      model: Offer,
      content: null
    });
    _defineProperty(this, "SalePageWithTrashedOffer", {
      id: 'sale-page-offer',
      fieldName: 'sale_page_with_trashed_offer',
      fieldTitle: 'Sale page offer',
      model: Offer,
      content: null
    });
    _defineProperty(this, "SalePagePixel", {
      id: 'sale-page-pixel',
      fieldName: 'sale_page_pixels',
      fieldTitle: 'Sale page pixels',
      type: 'json',
      content: null
    });
    _defineProperty(this, "SalePageAddons", {
      id: 'sale-page-addon',
      fieldName: 'sale_page_addons',
      fieldTitle: 'Sale page addon',
      model: Addons,
      //type: 'json',
      content: null
    });
    _defineProperty(this, "SalePageOrders", {
      id: 'sale-page-orders',
      fieldName: 'sale_page_orders',
      fieldTitle: 'Sale page orders',
      model: Order,
      content: null
    });
    _defineProperty(this, "SalePageVisitsCount", {
      fieldName: 'visit_logs_count',
      content: 0
    });
    _defineProperty(this, "SalePageOrdersCount", {
      fieldName: 'sale_page_orders_count',
      content: 0
    });
    _defineProperty(this, "SalePageDefaultSalePrice", {
      fieldName: 'default_sale_price',
      content: 0
    });
    _defineProperty(this, "DefaultCurrency", {
      fieldName: 'default_currency',
      content: SalePage.OFFER_COUNTRY_DEFAULT_CURRENCY
    });
    _defineProperty(this, "Currency", {
      fieldName: 'currency',
      content: null
    });
    _defineProperty(this, "CurrencySymbol", {
      fieldName: 'currency_symbol',
      content: null
    });
    _defineProperty(this, "customData", {
      fieldName: 'custom_data',
      model: CustomData,
      content: null
    });
    _defineProperty(this, "creationDate", {
      fieldName: 'created_at',
      content: null
    });
    _defineProperty(this, "updateDate", {
      fieldName: 'updated_at',
      content: null
    });
  }
  getCreationDate() {
    return this.creationDate.content;
  }
  getUpdateDate() {
    return this.updateDate.content;
  }
  static getDefaultCurrencies() {
    return [SalePage.EUR_DEFAULT_CURRENCY, SalePage.USD_DEFAULT_CURRENCY, SalePage.OFFER_COUNTRY_DEFAULT_CURRENCY];
  }
  static getPageLanguages() {
    return [SalePage.ENGLISH_LANGUAGE, SalePage.FRENCH_LANGUAGE, SalePage.ARABIC_LANGUAGE, SalePage.ITALIAN_LANGUAGE, SalePage.SPANISH_LANGUAGE];
  }
  getCurrency() {
    return this.Currency.content;
  }
  static isSalePage(sale_page) {
    return sale_page instanceof SalePage;
  }
  getPageName() {
    var _this$SalePageName;
    return (_this$SalePageName = this.SalePageName) === null || _this$SalePageName === void 0 ? void 0 : _this$SalePageName.content;
  }
  getName() {
    var _this$SalePageName2;
    return (_this$SalePageName2 = this.SalePageName) === null || _this$SalePageName2 === void 0 ? void 0 : _this$SalePageName2.content;
  }
  getPageLanguage() {
    var _this$SalePageLanguag;
    return (_this$SalePageLanguag = this.SalePageLanguage) === null || _this$SalePageLanguag === void 0 ? void 0 : _this$SalePageLanguag.content;
  }
  getLanguage() {
    var _this$SalePageLanguag2;
    return (_this$SalePageLanguag2 = this.SalePageLanguage) === null || _this$SalePageLanguag2 === void 0 ? void 0 : _this$SalePageLanguag2.content;
  }
  getDomainId() {
    var _this$SalePageDomainI;
    return (_this$SalePageDomainI = this.SalePageDomainID) === null || _this$SalePageDomainI === void 0 ? void 0 : _this$SalePageDomainI.content;
  }
  getSalePageOffer() {
    var _this$SalePageOffer;
    return (_this$SalePageOffer = this.SalePageOffer) === null || _this$SalePageOffer === void 0 ? void 0 : _this$SalePageOffer.content;
  }
  getDomain() {
    var _this$SalePageDomain$, _this$SalePageDomain;
    return (_this$SalePageDomain$ = (_this$SalePageDomain = this.SalePageDomain) === null || _this$SalePageDomain === void 0 ? void 0 : _this$SalePageDomain.content) !== null && _this$SalePageDomain$ !== void 0 ? _this$SalePageDomain$ : this.domain.content;
  }
  hasDomainDnsActive() {
    let domain = this.getDomain();
    return domain instanceof Store ? domain.hasDnsActive() : false;
  }
  hasDomainSslActive() {
    let domain = this.getDomain();
    return domain instanceof Store ? domain.hasSslActive() : false;
  }
  getNickName() {
    var _this$SalePageNickNam;
    return (_this$SalePageNickNam = this.SalePageNickName) === null || _this$SalePageNickNam === void 0 ? void 0 : _this$SalePageNickNam.content;
  }
  getProductTitle() {
    return this.SalePageProductTitle.content;
  }
  getSalePageLink(data = {
    _domain: null,
    nick_name: null,
    page_id: null
  }) {
    var _ref, _this$getDomain, _this$SalePageProduct, _this$getId;
    let {
      _domain,
      nick_name,
      page_id
    } = data;
    let hostname = window.location.hostname;
    let isLocalhost = hostname === 'localhost';
    let protocol = `http${isLocalhost ? '' : 's'}://`;
    let domain = (_ref = (_this$getDomain = this.getDomain()) !== null && _this$getDomain !== void 0 ? _this$getDomain : _domain) === null || _ref === void 0 || (_ref = _ref.DomainName) === null || _ref === void 0 ? void 0 : _ref.content;
    let port = isLocalhost ? ':3000' : '';
    let nickName = (_this$SalePageProduct = this.SalePageProductTitle) === null || _this$SalePageProduct === void 0 ? void 0 : _this$SalePageProduct.content;
    let urlDomain = domain ? [protocol, domain].join('') : process.env.VUE_APP_PAGE_DEFUALT_DOMAIN;
    let salePageId = (_this$getId = this.getId()) !== null && _this$getId !== void 0 ? _this$getId : page_id;
    let encodedId = toBase64(salePageId);
    let url = [urlDomain, port, '/', nickName, '/', encodedId].join('');
    return encodeURI(url);
  }
  getLink(...args) {
    return this.getSalePageLink(args);
  }
  getOfferCountry() {
    let offer = this.getSalePageOffer();
    return offer instanceof Offer ? offer.getOfferCountry() : null;
  }
  getProduct() {
    let offer = this.getOffer();
    return offer instanceof Offer ? offer.getProduct() : null;
  }
  getImage() {
    let product = this.getProduct();
    return product instanceof Product ? product.getImage() : null;
  }
  getCurrencySymbol() {
    return this.CurrencySymbol.content;
  }
  getSalePageOfferImage() {
    let offer = this.getSalePageOffer();
    return offer instanceof Offer ? offer.getOfferProductImage() : null;
  }
  getSalePageOfferImageUrl() {
    let image = this.getSalePageOfferImage();
    return image instanceof Image ? image.getUrl() : null;
  }
  getSalePageWithTrashedOffer() {
    var _this$SalePageWithTra, _this$SalePageWithTra2, _this$SalePageOffer2;
    return (_this$SalePageWithTra = (_this$SalePageWithTra2 = this.SalePageWithTrashedOffer) === null || _this$SalePageWithTra2 === void 0 ? void 0 : _this$SalePageWithTra2.content) !== null && _this$SalePageWithTra !== void 0 ? _this$SalePageWithTra : (_this$SalePageOffer2 = this.SalePageOffer) === null || _this$SalePageOffer2 === void 0 ? void 0 : _this$SalePageOffer2.content;
  }
  getSalePageSelectObject(with_object = false, text = 'text', value = 'value') {
    var _this$SalePageName3, _this$SalePageId;
    let item = {
      [text]: (_this$SalePageName3 = this.SalePageName) === null || _this$SalePageName3 === void 0 ? void 0 : _this$SalePageName3.content,
      [value]: (_this$SalePageId = this.SalePageId) === null || _this$SalePageId === void 0 ? void 0 : _this$SalePageId.content
    };
    if (with_object) item.sale_page = this;
    return item;
  }
  getSeller() {
    return this.SalePageUser.content;
  }
  getOffer(trashed = false) {
    var _this$SalePageOffer$c, _this$SalePageOffer4;
    if (trashed) {
      var _ref2, _ref3, _this$SalePageWithTra3, _this$SalePageOffer3;
      return (_ref2 = (_ref3 = (_this$SalePageWithTra3 = this.SalePageWithTrashedOffer.content) !== null && _this$SalePageWithTra3 !== void 0 ? _this$SalePageWithTra3 : this.withTrashedOffer.content) !== null && _ref3 !== void 0 ? _ref3 : (_this$SalePageOffer3 = this.SalePageOffer) === null || _this$SalePageOffer3 === void 0 ? void 0 : _this$SalePageOffer3.content) !== null && _ref2 !== void 0 ? _ref2 : this.offer.content;
    }
    return (_this$SalePageOffer$c = (_this$SalePageOffer4 = this.SalePageOffer) === null || _this$SalePageOffer4 === void 0 ? void 0 : _this$SalePageOffer4.content) !== null && _this$SalePageOffer$c !== void 0 ? _this$SalePageOffer$c : this.offer.content;
  }
  getOfferOptions() {
    var _this$SalePageOfferOp;
    return (_this$SalePageOfferOp = this.SalePageOfferOptions.content) !== null && _this$SalePageOfferOp !== void 0 ? _this$SalePageOfferOp : [];
  }
  getFirstOfferOption() {
    var _this$getOfferOptions;
    return (_this$getOfferOptions = this.getOfferOptions()) === null || _this$getOfferOptions === void 0 ? void 0 : _this$getOfferOptions[0];
  }
  getAddons() {
    return this.SalePageAddons.content;
  }
  getBlocks() {
    return this.SalePageBlocks.content;
  }
  getCustomData() {
    return this.customData.content;
  }
  getCustomShippingData() {
    let customData = this.getCustomData();
    return customData instanceof CustomData ? customData.getShippingData() : null;
  }
  getCustomReviewsData() {
    let customData = this.getCustomData();
    return customData instanceof CustomData ? customData.getReviewsData() : null;
  }
  getShortProductName() {
    return this.SalePageShortProductName.content;
  }
  getCheckoutTitle() {
    return this.checkoutSubTitle.content;
  }
  getCheckoutSubtitle() {
    return this.checkoutSubTitle.content;
  }
}
_defineProperty(SalePage, "ACTIVE_STATUS", 'active');
_defineProperty(SalePage, "DRAFT_STATUS", 'draft');
_defineProperty(SalePage, "PAUSED_STATUS", 'paused');
_defineProperty(SalePage, "LONG_CHECKOUT", 'long');
_defineProperty(SalePage, "SHORT_CHECKOUT", 'short');
_defineProperty(SalePage, "OFFER_COUNTRY_DEFAULT_CURRENCY", 'offer-country-currency');
_defineProperty(SalePage, "CUSTOM_CURRENCY", 'custom-currency');
_defineProperty(SalePage, "USD_DEFAULT_CURRENCY", 'USD');
_defineProperty(SalePage, "EUR_DEFAULT_CURRENCY", 'EUR');
_defineProperty(SalePage, "ENGLISH_LANGUAGE", 'en');
_defineProperty(SalePage, "SPANISH_LANGUAGE", 'es');
_defineProperty(SalePage, "ARABIC_LANGUAGE", 'ar');
_defineProperty(SalePage, "FRENCH_LANGUAGE", 'fr');
_defineProperty(SalePage, "ITALIAN_LANGUAGE", 'it');
export default SalePage;